import { filter } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { CgColorPicker } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import useResponsive from "../../hooks/useResponsive";
import ChevronDown from "../../icons/ChevronDown";
import Close from "../../icons/Close";
import Gallery from "../../icons/Gallery";
import HangerBG from "../../icons/HangerBG";
import { yodaOrdersActions } from "../../logic/actions";
import { getLocalizedString } from "../../utils";
import config from "../../utils/globalConfig";
import sizeSort from "../../utils/sizeSort";
import AvailabilityGridDoor from "../availability/AvailabilityGridDoor";
import { ColorTooltip } from "../common/ColorTooltip";
import { Price } from "../common/Price";
import { ProductImage } from "../common/ProductImage";
import Tooltip from "../common/Tooltip";
import { PopupImages } from "../product/PopupImages";
import TableSize from "../product/TableSize";
import ColorsSideBar from "./ColorsSideBar";
import MobileOrderDetail from "./MobileOrderDetail";
import OrderDetailInfo from "./OrderDetailInfo";
import OrderDetailTotal from "./OrderDetailTotal";
import OrderInfo from "./OrderInfo";
import OrderInfoRow from "./OrderInfoRow";
import { ToastMessage } from "./ToastMessage";
const OrderDetail = ({
  id,
  modelCode,
  collectionCode,
  line,
  collection,
  totalQuantityColorMap,
  expandAll,
  callbackRemoved,
  images,
}) => {
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";

  const mobileScrollAnchor = useRef();

  const { catalogueItemDetails } = useSelector((state) => state.yodaCatalogue);
  const { orderRowDetails, order, configuration } = useSelector(
    (state) => state.yodaOrders,
  );

  const { offsetTop } = useSelector((state) => state.system);

  const { customer } = useSelector((state) => state.yodaCustomer);
  const { me } = useSelector((state) => state.yodaStakeholders);

  const [expanded, setExpanded] = useState(1);
  const [deleteMessage, setDeleteMessage] = useState();
  const [removeProduct, setRemoveProduct] = useState(false);
  const [colorCode, setColorCode] = useState();
  const [mModelCode, setMModelCode] = useState();
  const [showAllColors, setShowAllColors] = useState(false);

  const [popupImages, setPopupImages] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [forceVisible, setForceVisible] = useState({});
  const [sessionAddedColors, setSessionAddedColors] = useState([]);
  const [tableView, setTableView] = useState(false);
  const [buttonTableView, setButtonTableView] = useState(false);
  const changeTableView = () => {
    setTableView(!tableView);
  };

  const dispatch = useDispatch();

  const { isMobile, isTablet, isDesktop } = useResponsive();
  const [showNumPad, setShowNumPad] = useState(false);

  const { imagedefault, rotationdefault } = useMemo(
    () => catalogueItemDetails?.[id] || {},
    [catalogueItemDetails, id],
  );

  useEffect(() => {
    if (id) setButtonTableView(catalogueItemDetails[id]?.findSizes);
  }, [catalogueItemDetails]);

  const sortColors = (colors) => {
    if (!Array.isArray(colors)) return [];
    const sorted = [...colors];
    return sorted.sort((a, b) => {
      const indexA = sessionAddedColors.findIndex((color) => color === a.code);
      const indexB = sessionAddedColors.findIndex((color) => color === b.code);
      if (indexA > -1 && indexB > -1) {
        return indexB - indexA;
      } else if (indexA > -1) {
        return -1;
      } else if (indexB > -1) {
        return 1;
      } else return 0;
    });
  };

  useEffect(() => {
    setForceVisible({ ...forceVisible, ...totalQuantityColorMap });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowNumPad(true);
    }, 400);
  }, []);

  useEffect(() => {
    expandAll ? setShowDetails(true) : setShowDetails(false);
  }, [expandAll]);

  const availabilityColorsMap = {
    green: "#249d4e",
    yellow: "#cea418",
    red: "#f04836",
  };

  function calculatedColors() {
    let tmpArr = {};
    catalogueItemDetails[id]?.catalog?.map((e) => {
      if (tmpArr[e.colorCode] === undefined) {
        tmpArr[e.colorCode] = {
          colorDescription: e.colorDescription?.[lang] || "",
          rgb: e.rgb,
          code: e.colorCode,
          values: [
            {
              size: e.size,
              sizeCode: e.sizeRowId,
              quantity: e.quantity,
            },
          ],
        };
      } else {
        tmpArr[e.colorCode].values.push({
          size: e.size,
          sizeCode: e.sizeRowId,
          quantity: e.quantity,
        });
      }
    });
    if (tmpArr === undefined) {
      return [];
    }

    let tmpArr2 = Object.keys(tmpArr).map(function (key) {
      return tmpArr[key];
    });

    return Array.from(tmpArr2);
  }

  let totalQuantity = 0;
  let totalPrice = 0;

  let totalQuantityC = {};
  let totalPriceC = {};

  let totalQuantityD = {};
  let totalPriceD = {};

  calculatedColors().map((e, index) => {
    order &&
      order?.customData?.doors &&
      order.customData.doors.map((d, idx) => {
        let catalogId = catalogueItemDetails[id]?.catalog.filter(
          (f) => f.colorCode == e.code,
        )[0].catalogId;

        //let tmpArr = filter(orderRowDetails, (k,v) => k.catalogId == catalogId)
        let tmpArr = filter(
          orderRowDetails,
          (orderRow, v) =>
            orderRow.catalogId == catalogId &&
            d == orderRow.customData.doorId &&
            orderRow?.customData?.typeId === config.ORDER_TYPE_REORDER,
        );

        tmpArr.forEach((e1) => {
          totalQuantity += e1.currentQuantity;
          totalPrice += e1.price;

          if (totalQuantityC[e.code] == undefined) {
            totalQuantityC[e.code] = e1.currentQuantity;
          } else {
            totalQuantityC[e.code] += e1.currentQuantity;
          }

          if (totalPriceC[e.code] == undefined) {
            totalPriceC[e.code] = e1.price;
          } else {
            totalPriceC[e.code] += e1.price;
          }

          if (e1?.customData?.doorId == d) {
            if (totalQuantityD[d] == undefined) {
              totalQuantityD[d] = e1.currentQuantity;
            } else {
              totalQuantityD[d] += e1.currentQuantity;
            }

            if (totalPriceD[d] == undefined) {
              totalPriceD[d] = e1.price;
            } else {
              totalPriceD[d] += e1.price;
            }
          }
        });
      });
  });

  let displayableQuantityD = [];
  let displayableQuantityString = "";
  Object.keys(totalQuantityD).forEach((e) => {
    displayableQuantityD.push([e, totalQuantityD[e]]);
    displayableQuantityString += "30px 30px ";
  });

  function expand() {
    setExpanded(expanded == 0 ? 1 : 0);
    dispatchEvent(
      new CustomEvent("collapsed", {
        bubbles: true,
        detail: {
          expand: expanded == 0 ? true : false,
        },
      }),
    );
  }

  function forceColorVisibility(color) {
    let tmpMap = { ...forceVisible };
    tmpMap[color] = 1;
    setForceVisible(tmpMap);
    setSessionAddedColors([...sessionAddedColors, color]);
    if (isMobile) {
      setTimeout(() => {
        mobileScrollAnchor?.current?.scrollIntoView?.({
          behavior: "smooth",
        });
      });
    }
  }

  function forceColorInvisibility(color) {
    let tmpMap = { ...forceVisible };
    tmpMap[color] = 0;
    setForceVisible(tmpMap);
    setSessionAddedColors(sessionAddedColors.filter((code) => code !== color));
    if (isMobile) {
      setTimeout(() => {
        mobileScrollAnchor?.current?.scrollIntoView?.({
          behavior: "smooth",
        });
      });
    }
  }

  function forceVisibleFromModal(code) {
    forceColorVisibility(code);
  }

  const click = (id, color, door, idx) => {
    const numericPad = document.getElementById(
      [id, color, door, idx].join("_"),
    );
    if (numericPad) numericPad.click();
  };

  return expanded === 0 ? (
    isMobile ? (
      <MobileOrderDetail
        id={id}
        modelCode={modelCode}
        previewImage={imagedefault}
        collectionCode={collectionCode}
        line={line}
        collection={collection}
        calculatedColors={calculatedColors()}
        sortColors={sortColors}
        totalQuantityColorMap={totalQuantityColorMap}
        totalQuantityC={totalQuantityC}
        totalPriceC={totalPriceC}
        expandAll={expandAll}
        totalQuantity={totalQuantity}
        totalPrice={totalQuantity}
        forceVisible={forceVisible}
        forceColorVisibility={(color) => forceColorVisibility(color)}
        forceColorInvisibility={(color) => forceColorInvisibility(color)}
        forceVisibleFromModal={(code) => forceVisibleFromModal(code)}
        {...{ sessionAddedColors }}
      />
    ) : (
      <Flex
        onClick={expand}
        style={{ position: "relative", cursor: "pointer" }}
        minHeight={["330px", "0px"]}
        mt={3}
        w={1}
        maxWidth={config.VIEWPORT}
        bg={"#F2F2F2"}
        flexDirection={"column"}
        fontSize="0.8em"
      >
        <ToastMessage
          message={deleteMessage}
          needConfirm={true}
          confirmFunction={(ev) => {
            dispatch(
              yodaOrdersActions.removeProduct(
                order.id,
                config.ORDER_TYPE_REORDER,
                id,
                mModelCode,
                colorCode,
              ),
            );
            if (removeProduct) {
              callbackRemoved();
            }
            setDeleteMessage(null);
            setRemoveProduct(false);
            setColorCode(null);
            setMModelCode(null);
            if (colorCode) {
              forceColorInvisibility(colorCode);
            }
            ev.preventDefault();
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
          }}
          cancelFunction={(ev) => {
            setDeleteMessage(null);
            setRemoveProduct(false);
            setColorCode(null);
            setMModelCode(null);
            ev.preventDefault();
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
          }}
          style={{ width: 600 }}
        />
        <Flex>
          <Box
            sx={{
              position: "relative",
              width: "285.37px",
              paddingTop: "25px",
              paddingLeft: ["15px", , , "27.8585px"],
              paddingBottom: ["15px", , , "25px"],
              paddingRight: "27.8585px",
            }}
          >
            <ProductImage
              img={imagedefault}
              scale={"1.2"}
              width={"100%"}
              height={"140px"}
            ></ProductImage>
          </Box>
          <Flex
            flexDirection={"column"}
            sx={{
              height: "100%",
              width: "100%",
              paddingBottom: ["15px", , , "25px"],
              paddingRight: ["15px", , , "25px"],
            }}
          >
            <OrderDetailInfo
              {...{
                expand,
                modelCode,
                collectionCode,
                configuration,
                order,
                collection,
                line,
              }}
            />
            {isDesktop && (
              <OrderDetailTotal
                displayDoors
                {...{
                  displayableQuantityD,
                  customer,
                  totalQuantity,
                  totalPrice,
                }}
              />
            )}
          </Flex>
        </Flex>
        {isTablet && (
          <OrderDetailTotal
            displayDoors
            {...{ displayableQuantityD, customer, totalQuantity, totalPrice }}
            sx={{
              margin: "0 15px",
            }}
          />
        )}
        {/* BUTTONS */}
        <Tooltip content={getLocalizedString("ORDER_DELETE_ITEM")}>
          <Box
            sx={{ "& > svg > g > g > line": { stroke: "white" } }}
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "15px",
              top: "10px",
              backgroundColor: "#232323",
              zIndex: 1,
            }}
            onClick={(evt) => {
              setMModelCode(modelCode);
              setDeleteMessage(
                getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                  modelCode +
                  " ?",
              );
              setRemoveProduct(true);
              evt.preventDefault();
              evt.stopPropagation();
              evt.nativeEvent.stopImmediatePropagation();
            }}
          >
            <Close style={{ width: 24, height: 24 }}></Close>
          </Box>
        </Tooltip>
        <Box
          onClick={expand}
          sx={{ "& > svg > g > g > line": { stroke: "white" } }}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            top: "10px",
            backgroundColor: "#ff9900",
          }}
        >
          {expanded == true && (
            <Tooltip content={getLocalizedString("ORDER_COLLAPSE_ROW")}>
              <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
                <ChevronDown
                  className="checvron.exp_true"
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Tooltip>
          )}

          {expanded == false && (
            <Tooltip content={getLocalizedString("ORDER_EXPAND_ROW")}>
              <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
                <ChevronDown
                  className="checvron.exp_false"
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Tooltip>
          )}
        </Box>
        {/* END - BUTTONS */}
      </Flex>
    )
  ) : isMobile ? (
    <>
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              order.id,
              config.ORDER_TYPE_REORDER,
              id,
              mModelCode,
              colorCode,
            ),
          );
          if (removeProduct) {
            callbackRemoved();
          }
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          if (colorCode) {
            forceColorInvisibility(colorCode);
          }
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      <Flex flexDirection="column" sx={{ position: "relative" }}>
        <Box
          sx={{ position: "absolute", top: -offsetTop, pointerEvents: "none" }}
          ref={mobileScrollAnchor}
        ></Box>
        {/* IMAGE & DETAILS */}
        <Flex justifyContent="left" width="100%">
          <ProductImage
            img={imagedefault}
            scale={"1.2"}
            width={"120px"}
            height={"190px"}
          ></ProductImage>
          <Flex width="calc(100% - 120px)" p="10px" flexDirection="column">
            <Flex
              width="100%"
              justifyContent="right"
              style={{ gap: "12px", zIndex: 1 }}
            >
              {showDetails ? (
                <Tooltip content={getLocalizedString("ORDER_COLLAPSE_ROW")}>
                  <BsChevronUp
                    size="24px"
                    onClick={() => setShowDetails(!showDetails)}
                  />
                </Tooltip>
              ) : (
                <Tooltip content={getLocalizedString("ORDER_EXPAND_ROW")}>
                  <BsChevronDown
                    size="24px"
                    onClick={() => setShowDetails(!showDetails)}
                  />
                </Tooltip>
              )}
              <Flex bg="black" alignItems="center">
                <IoMdClose
                  size="20px"
                  color="white"
                  onClick={(evt) => {
                    setMModelCode(modelCode);
                    setDeleteMessage(
                      getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                        modelCode +
                        " ?",
                    );
                    setRemoveProduct(true);
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.nativeEvent.stopImmediatePropagation();
                  }}
                />
              </Flex>
            </Flex>
            <Flex flexDirection="column">
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Codice modello")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{modelCode}</span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Codice collezione")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{collectionCode}</span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Linea")}:
                </span>
                <span style={{ fontWeight: "bold" }}>
                  {configuration
                    ?.filter?.((f) => f.typeId == order?.orderTypeId)?.[0]
                    ?.configuration?.filter((f) => f.line == line)[0]
                    ?.lineDescription?.[lang] || ""}
                </span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Collezione")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{collection}</span>
              </Box>
              <Flex
                alignItems="center"
                style={{ gap: "4px" }}
                mt="10px"
                onClick={() => setShowAllColors(!showAllColors)}
              >
                <CgColorPicker />
                <span style={{ fontSize: "14px" }}>
                  {getLocalizedString("COLORS AVAILABILITY")}
                </span>
              </Flex>
              {showAllColors && (
                <ColorsSideBar
                  colors={calculatedColors()}
                  id={id}
                  onClose={() => setShowAllColors(!showAllColors)}
                  forceVisible={forceVisibleFromModal}
                  offsetTop={50}
                />
              )}
            </Flex>
          </Flex>
        </Flex>
        {/* END - IMAGE & DETAILS */}
        {/* COLORS & AVAILABILITY */}
        {showDetails && (
          <Flex m="10px" flexDirection="column">
            <Flex
              width="100%"
              justifyContent="end"
              onClick={() => setShowDetails(!showDetails)}
            ></Flex>
            {sortColors(calculatedColors()).map((color, i) => (
              <Flex
                key={i}
                mb="4px"
                style={{
                  display:
                    (totalQuantityColorMap &&
                      totalQuantityColorMap[color.code] > 0) ||
                    forceVisible[color.code]
                      ? ""
                      : "none",
                }}
              >
                <OrderInfo
                  id={id}
                  color={color}
                  customer={customer}
                  totalPrice={totalPriceC[color.code]}
                  totalQuantity={totalQuantityC[color.code]}
                  catalogueItems={catalogueItemDetails}
                  expandAll={expandAll}
                  modelCode={modelCode}
                  forceVisible={forceVisible}
                  type={config.ORDER_TYPE_REORDER}
                  forceColorInvisibility={(color) =>
                    forceColorInvisibility(color)
                  }
                  isLastAdded={
                    sessionAddedColors?.includes?.(color.code) && i === 0
                  }
                />
              </Flex>
            ))}
          </Flex>
        )}
        {/* END - COLORS & AVAILABILITY */}
        <Flex
          alignItems="center"
          flex={1}
          sx={{
            gap: "2px",
            mx: "10px",
            fontWeight: "bold",
            borderTop: "1px solid #c2c2c2",
          }}
        >
          <Box width="33.3%" textAlign={"center"}>
            {getLocalizedString("TOTALE")}
          </Box>
          <Box width="66.6%">
            <OrderInfoRow
              quantity={totalQuantity || 0}
              price={totalPrice}
              isTotal
              bg={"#fff"}
            />
          </Box>
        </Flex>
      </Flex>
    </>
  ) : (
    <Flex
      style={{ position: "relative" }}
      mt={3}
      w={1}
      maxWidth={config.VIEWPORT}
      bg={"#F2F2F2"}
      flexDirection={["column", , , "row"]}
      fontSize={"0.8em"}
    >
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={() => {
          dispatch(
            yodaOrdersActions.removeProduct(
              order.id,
              config.ORDER_TYPE_REORDER,
              id,
              mModelCode,
              colorCode,
            ),
          );
          if (removeProduct) {
            callbackRemoved();
          }
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          if (colorCode) {
            forceColorInvisibility(colorCode);
          }
        }}
        cancelFunction={() => {
          setColorCode(null);
          setDeleteMessage(null);
          setRemoveProduct(false);
          setMModelCode(null);
        }}
        style={{ width: 600 }}
      />
      {/* PRODUCT IMAGE & COLORS */}
      <Box
        sx={{
          display: ["initial", "flex", , "initial"],
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: ["50%", , , "340px"],
            paddingTop: "25px",
            paddingLeft: "15px",
            paddingBottom: [0, , , "25px"],
            paddingRight: "27.8585px",
          }}
        >
          <ProductImage
            img={imagedefault}
            scale={"1.2"}
            width={"100%"}
            height={"190px"}
          ></ProductImage>

          <Tooltip content={getLocalizedString("GALLERY")}>
            <Box
              sx={{
                position: "absolute",
                right: 40,
                top: 30,
                zIndex: 3,
                cursor: "pointer",
                "&:hover": {
                  "svg > g > g > path": {
                    stroke: "#a2a2a2",
                  },
                  "svg > g > g > circle": {
                    stroke: "#a2a2a2",
                  },
                },
              }}
              onClick={(e) => {
                setPopupImages(true);
                e.preventDefault();
              }}
            >
              <Gallery style={{ width: 24, color: "#d2d2d2" }} />
            </Box>
          </Tooltip>

          <PopupImages
            id={id}
            open={popupImages}
            close={() => setPopupImages(false)}
            data={images}
            imageDefault={imagedefault.length > 0 ? imagedefault : ""}
            type={"REORDER"}
            colorComponentName="orderDetailsPopupReorderAndSwap"
            {...{ rotationdefault }}
          />

          <Flex width={1} p={2} bg={"white"} flexDirection={"column"}>
            <Flex
              width={1}
              justifyContent={"center"}
              justifySelf="center"
              bg={"white"}
              color="black"
              style={{
                borderTop: "1px solid gray",
                borderBottom: "1px solid gray",
              }}
            >
              {getLocalizedString("COLORS AVAILABILITY")}
            </Flex>
            <Flex
              width={1}
              flexDirection={["column", "row"]}
              justifyContent="left"
              alignItems={"center"}
              flexWrap={"wrap"}
            >
              {calculatedColors().map((e, i) => {
                const isSelected =
                  totalQuantityColorMap?.[e.code] ||
                  sessionAddedColors.includes(e.code);
                return (
                  <Box
                    key={`color-selectors-${i}`}
                    onClick={() => {
                      if (!isSelected) {
                        forceColorVisibility(e.code);
                      }
                    }}
                    sx={{
                      width: ["calc(100% / 3)", , , "50%"],
                      cursor: isSelected ? "default" : "pointer",
                    }}
                  >
                    <ColorTooltip
                      productId={id}
                      code={e.code}
                      colorDescription={e.colorDescription}
                      rgb={e.rgb}
                      componentName={"orderDetailsProductReorderAndSwap"}
                      type={"REORDER"}
                    />
                  </Box>
                );
              })}
            </Flex>
          </Flex>

          {!isTablet && <Flex height="30px" bg={"white"}></Flex>}
        </Box>
        {isTablet && (
          <OrderDetailInfo
            {...{
              expand,
              modelCode,
              collectionCode,
              configuration,
              order,
              collection,
              line,
            }}
          />
        )}
      </Box>
      {/* END - PRODUCT IMAGE & COLORS */}
      {/* SELECTED COLORS */}
      <Box
        sx={{
          position: "relative",
          flex: 1,
          width: ["100%", , , "unset"],
          paddingTop: ["15px", , , "25px"],
          paddingBottom: [0, , , "25px"],
          paddingRight: [0, , , "16.8585px"],
          marginLeft: [0, , , "-10px"],
        }}
        pl={0}
      >
        {isDesktop && (
          <OrderDetailInfo
            {...{
              expand,
              modelCode,
              collectionCode,
              configuration,
              order,
              collection,
              line,
            }}
          />
        )}
        {/* COLOR GRIDS */}
        {sortColors(calculatedColors()).map((e, index) => {
          return (
            <Box
              key={index}
              w={1}
              p={2}
              sx={{
                position: "relative",
                mx: [0, , "15px", 0],
                marginBottom: 3,
                display:
                  (totalQuantityColorMap &&
                    totalQuantityColorMap[e.code] > 0) ||
                  forceVisible[e.code]
                    ? ""
                    : "none",
              }}
              bg="white"
            >
              <Flex width={"100%"} overflowX={"auto"}>
                {/* <Flex width={"100%"}> */}
                <Box
                  bg="white"
                  width={"100%"}
                  sx={{
                    display: "grid",
                    gridGap: 0,
                    flexGrow: 1,
                    gridTemplateColumns:
                      "100px 120px " +
                      e.values.map((v) => "1fr ").join("") +
                      "50px 100px",
                  }}
                >
                  {/* ROW 1 */}
                  <Box
                    style={{
                      border: "1px solid #E0E0E0",
                      borderTop: 0,
                      borderBottom: 0,
                      borderLeft: 0,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      minHeight: "35px",
                      fontSize: "12px",
                      background: "#fff",
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                    }}
                    w={1}
                  >
                    {getLocalizedString("COLOR")}
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #E0E0E0",
                      borderTop: 0,
                      borderBottom: 0,
                      borderLeft: 0,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      fontSize: "12px",
                      background: "#fff",
                      position: "sticky",
                      left: "100px",
                      zIndex: 1,
                      textDecoration: buttonTableView ? "underline" : "none",
                      cursor: buttonTableView ? "pointer" : "default",
                    }}
                    onClick={buttonTableView ? changeTableView : null}
                  >
                    <HangerBG
                      style={{
                        paddingRight: "10px",
                      }}
                    />
                    {getLocalizedString("SIZE")}
                  </Box>
                  {e.values.sort(sizeSort).map((e1, idx) => (
                    <Box
                      key={idx}
                      style={{
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        borderLeft: 0,
                        borderBottom: 0,
                        textAlign: "center",
                        borderRight:
                          e.values.length - 1 == idx ? 0 : "1px solid #E0E0E0",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minWidth: "20px",
                      }}
                      color={"black"}
                      fontWeight="bold"
                    >
                      <Flex
                        w={1}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        {e1.size}
                      </Flex>
                    </Box>
                  ))}
                  <Box
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #F2F2F2",
                    }}
                  ></Box>
                  <Box
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #F2F2F2",
                    }}
                  ></Box>
                  {/* END - ROW 1 */}
                  {/* ROW 2 */}
                  <Box
                    style={{
                      textAlign: "center",
                      border: "1px solid #E0E0E0",
                      borderLeft: 0,
                      borderBottom: 0,
                      gridRow:
                        "span " +
                        (order && order?.customData?.doors?.length + 1),
                      background: "#fff",
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                    }}
                  >
                    <Box
                      style={{
                        fontWeight: "bold",
                        paddingTop: "7px",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                      }}
                    >
                      {e.colorDescription.toUpperCase()}
                    </Box>
                    <ColorTooltip
                      id={id}
                      code={e.code}
                      colorDescription={e.colorDescription}
                      rgb={e.rgb}
                      componentName={"orderDetailsGrillReorderAndSwap"}
                      type={"REORDER"}
                      enableMobileTooltip
                    />
                  </Box>
                  <Box
                    style={{
                      textAlign: "center",
                      border: "1px solid #E0E0E0",
                      borderLeft: 0,
                      borderBottom: "1px solid #E0E0E0",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      minHeight: "35px",
                      color: "#666666",
                      fontSize: "12px",
                      background: "#fff",
                      position: "sticky",
                      left: "100px",
                      zIndex: 1,
                    }}
                  >
                    {getLocalizedString("AVAILABILITY")}
                  </Box>

                  {e.values.sort(sizeSort).map((e1, idx) => (
                    <Box
                      key={idx}
                      color={"white"}
                      style={{
                        textAlign: "center",
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        borderLeft: 0,
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                      }}
                      bg={
                        e1.quantity > 0
                          ? availabilityColorsMap["green"]
                          : availabilityColorsMap["red"]
                      }
                    >
                      {me?.role.includes?.("CustomerCare") ? e1.quantity : ""}
                    </Box>
                  ))}

                  <Box
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      fontSize: "12px",
                    }}
                    bg={"#646464"}
                    color={"white"}
                  >
                    {getLocalizedString("QTA")}
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #E0E0E0",
                      borderTop: 0,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "left",
                      width: "100%",
                      alignItems: "center",
                      paddingLeft: "20px",
                    }}
                    bg={"#646464"}
                    color={"white"}
                  >
                    {customer?.currencySymbol}
                  </Box>
                  {/* END - ROW 2 */}
                  {/* DOORS */}
                  {order?.customData?.doors?.map((doorId, idx) => (
                    <AvailabilityGridDoor
                      key={`door-${idx}-${doorId}`}
                      doorId={doorId}
                      color={e}
                      productId={id}
                      catalog={catalogueItemDetails[id]?.catalog}
                      orderType={config.ORDER_TYPE_REORDER}
                    />
                  ))}
                  {/* END - DOORS */}
                  {/* COLOR TOTALS */}
                  <Box></Box>
                  <Box></Box>
                  {e.values.sort(sizeSort).map((e1, idx) => (
                    <Box key={idx}></Box>
                  ))}
                  <Box
                    style={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    {totalQuantityC[e.code] || 0}
                  </Box>
                  <Box
                    style={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <Price price={totalPriceC[e.code]}></Price>
                  </Box>
                  {/* END - COLOR TOTALS */}
                </Box>
              </Flex>
              <Tooltip content={getLocalizedString("ORDER_DELETE_ITEM_COLOR")}>
                <Box
                  sx={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "12px",
                    top: "10px",
                  }}
                  onClick={() => {
                    setColorCode(e.code);
                    setMModelCode(modelCode);
                    setDeleteMessage(
                      getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                        modelCode +
                        "(" +
                        e.code +
                        ") ?",
                    );
                    setRemoveProduct(false);
                  }}
                >
                  <Close style={{ width: "16px", height: "16px" }} />
                </Box>
              </Tooltip>
            </Box>
          );
        })}
        {/* END - COLOR GRIDS */}
        <OrderDetailTotal
          {...{ customer, totalQuantity, totalPrice }}
          sx={{
            margin: [0, , "0 15px 15px", 0],
          }}
        />
      </Box>
      {/* SELECTED COLORS */}
      {/* BUTTONS */}
      <Box
        onClick={expand}
        sx={{ "& > svg > g > g > line": { stroke: "white" } }}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "15px",
          top: "10px",
          backgroundColor: "#ff9900",
        }}
      >
        {expanded == true && (
          <Tooltip content={getLocalizedString("ORDER_COLLAPSE_ROW")}>
            <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
              <ChevronDown
                className="checvron.exp_true"
                style={{ transform: "rotate(180deg)", width: 24, height: 24 }}
              />
            </Box>
          </Tooltip>
        )}

        {expanded == false && (
          <Tooltip content={getLocalizedString("ORDER_EXPAND_ROW")}>
            <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
              <ChevronDown
                className="checvron.exp_false"
                style={{ transform: "rotate(180deg)", width: 24, height: 24 }}
              />
            </Box>
          </Tooltip>
        )}
      </Box>
      <Tooltip content={getLocalizedString("ORDER_DELETE_ITEM")}>
        <Box
          sx={{ "& > svg > g > g > line": { stroke: "white" } }}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            top: "10px",
            backgroundColor: "#232323",
            zIndex: 1,
          }}
          onClick={() => {
            setMModelCode(modelCode);
            setDeleteMessage(
              getLocalizedString("DELETEORDER_ITEM_MESSAGE") + modelCode + " ?",
            );
            setRemoveProduct(true);
          }}
        >
          <Close style={{ width: 24, height: 24 }}></Close>
        </Box>
      </Tooltip>
      {tableView && <TableSize onClose={changeTableView} />}
      {/* END - BUTTONS */}
    </Flex>
  );
};

export { OrderDetail };
